module.exports = __webpack_public_path__ + "img/CheckIcon.ade10f6c.svg";